import { takeEvery, call, put, takeLatest } from 'redux-saga/effects';
import {
  signInRequest,
  signInSuccess,
  error,
  meRequest,
  meSuccess,
  initialLoadRequest,
  initialLoadSuccess,
  initialLoadUnauthenticated,
  logoutRequest,
  logoutSuccess,
  forgotPasswordRequest,
  forgotPasswordSuccess,
  resetPasswordRequest,
  resetPasswordSuccess,
  getAvailableBusinesses,
  setCurrentAndAllBusiness,
} from '../../ducks/UserDucks';
import history from '../../../utils/history';
import { ROOT_PATH } from '../../../constants/routes';
import storage from '../../../utils/storage';
import Authentication from '../../../utils/authentication';
import OwnerAuthentication from '../../../utils/ownerAuthentication';
import AppSetupAuthentication from '../../../utils/appSetupAuthentication';
import { enqueueSnackbar } from '../../ducks/SnackbarDucks';
import { getBusiness } from '../../../services/RestaurantsService';

function* signIn(action) {
  try {
    const { email, password } = action.payload;
    const token = yield call(Authentication.login, email, password);
    yield put(
      signInSuccess({
        token,
      })
    );
    const profile = yield call(Authentication.getProfile);
    yield put(
      meSuccess({
        user: profile,
      })
    );
    history.push(ROOT_PATH);
  } catch (err) {
    yield put(
      enqueueSnackbar({
        message: err.message,
        options: {
          variant: 'error',
        },
      })
    );
    yield put(error({}));
    storage.remove('restaurantInfo');
    yield call(Authentication.logout);
    yield call(OwnerAuthentication.logout);
    yield call(AppSetupAuthentication.logout);
  }
}

function* fetchUser() {
  try {
    const profile = yield call(Authentication.getProfile);
    yield put(
      meSuccess({
        user: profile,
      })
    );
  } catch (err) {
    yield put(
      enqueueSnackbar({
        message: err.message,
        options: {
          variant: 'error',
        },
      })
    );
    yield put(error({ message: err.message }));

    storage.remove('restaurantInfo');
    yield call(Authentication.logout);
    yield call(OwnerAuthentication.logout);
    yield call(AppSetupAuthentication.logout);
  }
}

function* signOut(action) {
  const message = yield call(Authentication.logout, action.payload);

  yield call(OwnerAuthentication.logout);
  yield call(AppSetupAuthentication.logout);

  storage.remove('restaurantInfo');

  yield put(logoutSuccess());
  if (message) {
    yield put(enqueueSnackbar(message));
  }
}

function* initialUserLoad() {
  try {
    const token = yield call(Authentication.getToken);
    if (!token) return yield put(initialLoadUnauthenticated());
    const profile = yield call(Authentication.getProfile);
    const businesses = yield call(getBusiness);
    yield put(
      initialLoadSuccess({
        user: profile,
        currentBusiness: businesses[0],
        allBusinesses: businesses,
      })
    );
  } catch (err) {
    yield put(error({ message: err.message }));
  }
}

function* forgotPassword(action) {
  try {
    const { email } = action.payload;
    yield call(Authentication.forgotPasswordRequest, email);
    yield put(forgotPasswordSuccess());
    yield put(
      enqueueSnackbar({
        message: 'Please check your email',
      })
    );
  } catch (err) {
    yield put(
      enqueueSnackbar({
        message: err.message,
        options: {
          variant: 'error',
        },
      })
    );
    yield put(error({}));
  }
}

function* resetPassword(action) {
  try {
    const { email, code, password } = action.payload;
    yield call(Authentication.resetPasswordRequest, {
      email,
      resetCode: code,
      password,
    });
    yield put(resetPasswordSuccess());
    yield put(
      enqueueSnackbar({
        message: 'Password updated',
      })
    );
    history.push(ROOT_PATH);
  } catch (err) {
    yield put(
      enqueueSnackbar({
        message: err.message,
        options: {
          variant: 'error',
        },
      })
    );
    yield put(error({}));
  }
}

function* getAvailableBusinessesSaga() {
  try {
    const businesses = yield call(getBusiness);
    yield put(
      setCurrentAndAllBusiness({
        currentBusiness: businesses[0],
        allBusinesses: businesses,
      })
    );
  } catch (err) {
    yield put(
      enqueueSnackbar({
        message: err.message,
        options: {
          variant: 'error',
        },
      })
    );
    yield put(error({ message: err.message }));
  }
}

export default function* watchUser() {
  yield takeEvery(signInRequest, signIn);
  yield takeEvery(logoutRequest, signOut);
  yield takeEvery(meRequest, fetchUser);
  yield takeEvery(initialLoadRequest, initialUserLoad);
  yield takeEvery(forgotPasswordRequest, forgotPassword);
  yield takeEvery(resetPasswordRequest, resetPassword);
  yield takeLatest(getAvailableBusinesses, getAvailableBusinessesSaga);
}
